<template lang="">
  <div class="bbs_filter">
    <div class="lft_area">
      <div class="bbs_info">
        <div class="total"><strong>
          {{ getCurrentCount() }}
        </strong> / {{ this.funeralListCount }}</div>
      </div>
    </div>
    <div class="rgt_area">
      <div class="bbs_srch">
        <select name="" id="" class="i_sel" v-model="searchType">
          <option
            v-for="option in searchOptions"
            :value="option.value"
          >{{ option.name }}</option>
        </select>
        <input type="text" class="i_txt" name="keyword" v-model="searchWord">
        <button type="button" class="bt_base gray btn_srch" @click="getSearch">검색</button>
      </div>
    </div>
  </div>

  <div class="bbs_list">
    <table class="bbs_tbl">
      <colgroup>
        <col style="width:40px">
        <col style="width:100px">
        <col style="width:100px">
        <col style="width:150px">
        <col style="width:200px">
        <col style="width:150px">
        <col style="width:auto">
        <col style="width:150px">
      </colgroup>
      <thead>
        <tr>
          <th scope="col">번호</th>
          <th scope="col">주문번호</th>
          <th scope="col">장례식날짜</th>
          <th scope="col">캠페인</th>
          <th scope="col">고인/상주</th>
          <th scope="col">장례식장</th>
          <th scope="col">상세주소</th>
          <th scope="col">비고</th>
        </tr>
      </thead>
      <tbody>
        <tr
          v-for="(funeral, index) in funeralList"
        >
          <td>{{ index + 1 }}</td>
          <td>{{ funeral.orderNum }}</td>
          <td>
            <div class="ui_datetime">
              <span class="date">{{ funeral.funeralDate }}</span>
              <span class="time"> {{ funeral.funeralTime }}</span>
            </div>
          </td>
          <td class="subject type_wider">{{ funeral.campaignName }}</td>
                    <td>
            <div class="ui_datetime">
              <span class="date">고인명: {{ funeral.deceasedName }} ({{ funeral.mainMournerId }}) <br/></span>
              <span class="time">상주명: {{ funeral.mainMournerName }} ({{ funeral.mainMournerPhone }})</span>
            </div>
          </td>
          <td>
            <div class="ui_datetime">
              <span class="date">{{ funeral.funeralLocationName }}</span>
              <span class="time">{{ funeral.funeralLocationDtl }}</span>
            </div>
          </td>
          <td class="subject type_wider">{{ funeral.mapAddress }}</td>
          <td>
            <div class="ui_datetime">
              <span class="date">
                    <a
                          v-bind:href="'/invitation/' + funeral.orderNum"
                          class="btn_view"
                          target="_blank"
                          >부고장
                    </a> |
              </span>
              <span class="time">
                    <a
                          v-bind:href="'/invitation/kiosk/' + funeral.orderNum + '?kioskStyle=' + funeral.kioskStyle + '&page=1'"
                          class="btn_view"
                          target="_blank"
                          >키오스크
                    </a>
              </span>
            </div>

          </td>
        </tr>
      </tbody>
    </table>
  </div>

  <div class="paginate">
    <AdminPagination
      :totalPages = "totalPages()"
      :currentPage = "currentPage"
      @changePage = "changePage"
    />

    <div class="rgt_area">
    </div>
  </div>
</template>
<script>
import { mapActions, mapState } from 'vuex';
import AdminPagination from '@/components/common/AdminPagination.vue';

const adminFuneralModule = 'adminFuneralModule'

export default {
  components: {
    AdminPagination
  },

  data () {
    return {
      currentPage: 1,

      searchOptions: [
        { name: '전체', value: 'all' },{ name: '고인명', value: 'deceased' },{ name: '상주명', value: 'mourners' },
        { name: '장례식장', value: 'location' },
      ],
      searchType: '',
      searchWord: ''
    }
  },

  methods: {
    ...mapActions(adminFuneralModule, [
      'requestFuneralList'
    ]),


    totalPages() {
      return Math.ceil(this.funeralListCount / 10);
    },

    async changePage(page) {
      this.currentPage = page
      const {currentPage, searchType, searchWord} = this
      await this.requestFuneralList({currentPage, searchType, searchWord})
    },

    getCurrentCount() {
      const currentFirstCount = (this.currentPage - 1) * 10 + 1
      let currentLastCount = this.currentPage * 10
      if (parseInt(currentLastCount) > parseInt(this.funeralListCount)) {
        currentLastCount = this.funeralListCount
      }
      return currentFirstCount + '-' + currentLastCount
    },

    inviOpen (url) {
      window.open(url);
    },

    async getSearch() {
      if (this.searchWord === '') {
        //alert('검색어를 입력해주세요')
        //return
      }
      this.currentPage = 1
      const {currentPage, searchType, searchWord} = this
      await this.requestFuneralList({currentPage, searchType, searchWord})
    }


  },

  computed: {
     ...mapState(adminFuneralModule, [
      'funeralList',
      'funeralListCount'
    ]),
  },

  async mounted() {
    const {currentPage, searchType, searchWord} = this
    await this.requestFuneralList({currentPage, searchType, searchWord})
    this.searchType = 'all'
  }
}
</script>
<style lang="">

</style>